var exports = {
  "zr": "ScreenShareBufferingFrame.module__root___eEN5eU",
  "WO": "ScreenShareBufferingFrame.module__corner___eEN5eU",
  "u1": "ScreenShareBufferingFrame.module__spinner___eEN5eU",
  "MI": "ScreenShareBufferingFrame.module__failureContent___eEN5eU",
  "nV": "ScreenShareBufferingFrame.module__failureTitle___eEN5eU",
  "eB": "ScreenShareBufferingFrame.module__failureSubtext___eEN5eU",
  "sM": "ScreenShareBufferingFrame.module__srOnly___eEN5eU",
  "Om": "ScreenShareBufferingFrame.module__dot___eEN5eU",
  "wV": "ScreenShareBufferingFrame.module__dot0___eEN5eU",
  "TQ": "ScreenShareBufferingFrame.module__dot1___eEN5eU",
  "Mc": "ScreenShareBufferingFrame.module__dot2___eEN5eU",
  "FA": "ScreenShareBufferingFrame.module__dot3___eEN5eU",
  "yY": "ScreenShareBufferingFrame.module__dot4___eEN5eU",
  "Ff": "ScreenShareBufferingFrame.module__dot5___eEN5eU",
  "Mi": "ScreenShareBufferingFrame.module__dot6___eEN5eU",
  "FG": "ScreenShareBufferingFrame.module__dot7___eEN5eU",
  "MZ": "ScreenShareBufferingFrame.module__dot8___eEN5eU",
};

module.exports = exports;
